
import React from 'react';
import { Button } from '@/components/ui/button';

interface RegisterFormSubmitButtonProps {
  isLoading: boolean;
}

export const RegisterFormSubmitButton: React.FC<RegisterFormSubmitButtonProps> = ({
  isLoading,
}) => {
  return (
    <Button type="submit" className="w-full mb-4" disabled={isLoading}>
      {isLoading ? 'Registering...' : 'Register'}
    </Button>
  );
};
